import React, { Component } from 'react';
import { FLOW_TYPE, REDIRECT_SUFFIX } from '../../../../framework/App/AppConstants';
import { trackTransition } from '../../../../framework/store/FPTI/FPTIActions';
import { triggerEnsightenEvent } from '../../../../framework/store/Ensighten/EnsightenActions';
import { ENSIGHTEN_APP_DECLINED } from '../../../../framework/store/Ensighten/EnsightenConstants';
import Header from '../../../components/Header/Header';
import Footer from '../../../components/Footer/Footer';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import RedirectButton from '../../../../shared-components/RedirectButton/RedirectButton';
import '../../../styles/base-de.less';
import _ from 'lodash';

const LOCALE_PREFIX = 'DE/pages/DecisionPage/DecisionPage';

// see creditResponseLib => handleApplicationStatus() => displayResponses
const DECISION_MAP = {
    DECLINED: 'creditDeclineHard',
    INELIGIBLE: 'creditIneligible',
    UNKNOWN_DECISION: 'unknownDecision'
};

export class DecisionPage extends Component {
    static propTypes = {
        applicationStatus: PropTypes.string.isRequired,
        flow: PropTypes.oneOf(Object.values(FLOW_TYPE)),
        intl: intlShape.isRequired,
        merchantName: PropTypes.string,
        messages: PropTypes.object.isRequired,
        onComponentDidMount: PropTypes.func.isRequired
    };
    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount(this.props);
    }

    render() {
        const {
            intl,
            applicationStatus,
            flow,
            merchantName,
            messages
        } = this.props;
        // "DECISION" maps to "creditDeclineHard", etc
        let appStatus = DECISION_MAP[applicationStatus] || applicationStatus;
        // if we have no keys for this status, then use "unknownDecision"
        if (!_.get(messages, `${LOCALE_PREFIX}.decision.${appStatus}`)) {
            appStatus = 'unknownDecision';
        }
        const getMessage = (key, keySuffix) => {
            let id = `${LOCALE_PREFIX}.decision.${appStatus}.${key}`;
            const idWithSuffix = `${id}${keySuffix}`;
            if (keySuffix && _.has(messages, idWithSuffix)) {
                id = idWithSuffix;
            }
            return intl.formatMessage({ id, defaultMessage: ' ' }, {
                merchantName,
                emptySpace: ' '
            });
        };
        const messageHeader = getMessage('header');
        const declinedButtonLabel = getMessage('declinedButtonLabel');
        const messagePrimaryKey = 'primaryMessage';
        const messageSecondaryKey = 'secondaryMessage';
        let keySuffix;
        if (
            merchantName &&
            typeof merchantName === 'string' &&
            merchantName.length
        ) {
            keySuffix = '_merchant';
        }
        const messagePrimary = getMessage(messagePrimaryKey, keySuffix);
        const messageSecondary = getMessage(messageSecondaryKey, keySuffix);
        return (
            <div className="outerWrapper de-wrapper">
                <div id="wrapper">
                    <div id="main">
                        <div id="DecisionPage">
                            <Header singleColumnLayout={true} />
                            <section id="declined" className="contentSection">
                                <div className="row-fluid container">
                                    <span className="span24">
                                        <h2 className="alpha">
                                            {messageHeader}
                                        </h2>
                                        <p>{messagePrimary}</p>
                                        <p>{messageSecondary}</p>
                                        <div className="row-fluid">
                                            <span className="span14">
                                                <div className="buttons">
                                                    <RedirectButton
                                                        ctaLabel={declinedButtonLabel}
                                                        className="decisionReturnFlowAction"
                                                        buttonId="declinedContinue"
                                                        actionUri={REDIRECT_SUFFIX.RETURN_REDIRECT}
                                                    />
                                                </div>
                                            </span>
                                        </div>
                                    </span>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    applicationStatus: _.get(
        state,
        'serverData.decisionModel.applicationStatus',
        'unknownStatus'
    ),
    flow: _.get(state, 'serverData.flow'),
    merchantName: _.get(state, 'serverData.merchantName'),
    messages: _.get(state, 'serverData.messages')
});

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(trackTransition('pp_credit_decisionpage', 'prepare_pp_credit_decisionpage'));
        dispatch(triggerEnsightenEvent(ENSIGHTEN_APP_DECLINED));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(DecisionPage));
